/*
 * @Descripttion:
 * @Author: yuanjianlong@gaosiedu.com
 * @Date: 2019-11-20 14:18:05
 * @LastEditors: yuanjianlong
 * @LastEditTime: 2025-10-23 18:35:34
 */
/**
 * demo
 */
const baseUrl = process.env.VUE_APP_BASEURL;
const baseUrlChange = process.env.VUE_APP_BASEURL_CHANGE;

export default {
  // 权限判断
  getPageAccess: `${baseUrlChange}/common/pageAccess`,
  // 获取用户信息
  getMenu: `${baseUrlChange}/common/userInfo`,
  // 获取班级数量
  getClassNum: `${baseUrlChange}/class/num`,
  // 获取筛选条件-选择班级课程页
  getMyCondition: `${baseUrlChange}/class/criterion`,
  // 获取我的班级及课程历史记录
  getMyClassAndType: `${baseUrlChange}/class/classes`,
  // 获取上次备课记录
  getLastLesson: `${baseUrlChange}/preLesson/lastLesson`,
  // 猜你想要合并接口--> 快速上课
  getFastClass: `${baseUrlChange}/preLesson/fastClass`,
  // 即将上课提醒
  getComingClass: `${baseUrlChange}/preLesson/comingClass`,
  // 获取科目
  getSubject: `${baseUrlChange}/preLesson/getSubject`,
  // 获取学科
  getSubjectPro: `${baseUrlChange}/preLesson/subjectProIdBySubject`,
  // 获取筛选条件
  getCondition: `${baseUrlChange}/preLesson/condition`,
  // 获取班型列表
  getClassTypeList: `${baseUrlChange}/preLesson/classTypeList`,
  // 获取讲次列表
  getLessonList: `${baseUrlChange}/preLesson`,
  // 保存用户选择班级（班级）记录
  saveHistory: `${baseUrlChange}/preLesson/classType`,
  // 查看板书截图列表
  getBanshuList: `${baseUrlChange}/msPenInk/queryScreenshotByLessonId`,
  // 获取课程合照列表
  getPhotoList: `${baseUrlChange}/msPenInk/queryMsPhotoByLessonId`,
  // 删除班型
  delClassType: `${baseUrlChange}/class/classType`,
  // 搜索班型
  searchClassType: `${baseUrlChange}/preLesson/searchClassType`,

  // 获取当前教师所有精准学班级列表
  getAccurateList: `${baseUrlChange}/ps/classes`,

  // 获取当前讲此的所有知识点及内容
  knowledgeParentList: `${baseUrlChange}/lesson/knowledgeParentList`,

  // 更新讲次信息
  changeLesson: `${baseUrlChange}/ps/classes/lessons/changeLesson`,
  // ab测试接口
  abTest: `${baseUrlChange}/common/abTest`,
  // ============================以上为用到接口

  // 授课权限判断
  verification: `${baseUrl}/shouke/verification`,

  getAdminList: `${baseUrl}/shouke/adminAndEducational`,

  getDetail: `${baseUrl}/bkLessonDetail/getDetail`,

  getHandoutTopic: `${baseUrl}/bkLessonDetail/getHandoutTopic`,
  // 考区列表
  getExamArea: `${baseUrl}/bkLessonDetail/getExamArea`,
  // 保存设置的考区
  saveExamArea: `${baseUrl}/bkLessonDetail/saveExamArea`,
  // 学员作业详情
  getStudentHomeworkTopicInfo: `${baseUrl}/studentTask/getStudentHomeworkTopicInfo`,
  // 本讲作业正确率信息
  getStudentRatioInfo: `${baseUrl}/studentTask/getStudentRatioInfo`,
  // 获取讲次序号和名称
  getLessionDetail: `${baseUrl}/studentTask/getLessionDetail`,
  // 获取左侧课程列表
  getLessonListByClassId: `${baseUrl}/studentTask/getLessonList`,
  // 题目和简答
  getQuestionDetail: `${baseUrl}/studentTask/getQuestionDetail`,
  // 获取个性化教案数据
  getModule: `${baseUrl}/prepareLesson/getModule`,
  // 更新模块时长
  updateModuleTime: `${baseUrl}/prepareLesson/updateModuleTime`,
  // 更新本讲备课任务
  updateLessonTask: `${baseUrl}/prepareLesson/updateTask`,
  // 详略标签处理
  updataLabelStatus: `${baseUrl}/prepareLesson/updatePieceStatus`,
  // 获取预览打印之课程所属信息
  getPrintLessonInfo: `${baseUrl}/prepareLesson/coursePrintInfo`,
  getPrintLesson: `${baseUrl}/bkLesson/getPrintLesson`,
  // 教师讲义打印（diy）
  getPrintLesson4Diy: `${baseUrl}/bkLesson/getPrintLesson4Diy`,
  // 是否提示切换编辑考区
  getCustomDistrictOldExam: `${baseUrl}/bkLessonDetail/getCustomDistrictOldExam`,
  // 根据讲次id获取视频列表
  getVideosById: `${baseUrl}/beiShouKe/videos/v1`, // beiShouKe/videos/v1
  // 新版目录
  getDetailNew: `${baseUrl}/beiShouKe/content/v1`,
  // 课件目录
  getCoursewareCatalog: `${baseUrl}/beiShouKe/coursewareCatalogLevel`,
  // 获取课件个人批注
  getRemark: `${baseUrl}/beiShouKe/modules`,
  // 修改个人备注
  updateLessonRemark: `${baseUrl}/prepareLesson/updateLessonRemark`,
  // 备课随机提问模式学生
  getStudentListMock: `${baseUrl}/beiShouKe/getStudentList`,
  // 备课随机提问模式学生 未到
  absentStudentMock: `${baseUrl}/beiShouKe/absentStudent`,
  // 获取语文批注教案
  getChineseGuide: `${baseUrl}/bkLessonDetail/chinese/guide`,

  getPolyvToken: `${baseUrl}/polyv/getPolyvToken`,
  // 查询新手引导
  getOption: `${baseUrl}/option/getOption`,
  // 更新新手引导
  updateOptionStatus: `${baseUrl}/option/updateOptionStatus`,

  // 降级处理接口
  getClassList: `${baseUrl}/downgrade/classes`,
  getLessons: `${baseUrl}/downgrade/lessons`,
  getCourseware: `${baseUrl}/downgrade/courseware`,
  // 快速建班-获取信息
  newClass: `${baseUrl}/beiShouKe/newClass/index`,
  // 快速建班-保存
  saveNewClass: `${baseUrl}/beiShouKe/newClass/save`,
  // 课件目录
  getCoursewareCatalogLevel: `${baseUrl}/beiShouKe/coursewareCatalogLevel`,
  // 获取班级课堂数据列表
  getMsClassReviewInfo: `${baseUrlChange}/ms/review/getMsClassReviewInfo`,
  // 获取学生答题详情
  getMsClassStudentReviewDetail: `${baseUrlChange}/ms/review/getMsClassStudentReviewDetail`,
  // 复评题目
  msPcTopicReEvaluation: `${baseUrlChange}/ms/review/msPcTopicReEvaluation`,
  // 获取班级列表
  getBkClassList: `${baseUrlChange}/ms/newReview/classes`,
  // 获取讲次列表
  getBkLessonList: `${baseUrlChange}/ms/newReview/{businessId}/{type}/{newDiyFlag}/lessonList`,
  // 获取讲次视角数据
  getBkLessonView: `${baseUrlChange}/ms/newReview/getMsClassReviewInfo`,
  // 获取学生视角数据
  getMsClassLessonReviewInfo: `${baseUrlChange}/ms/newReview/getMsClassLessonReviewInfo`,
  // 新获取学生答题详情
  getMsClassStudentReviewDetailNew: `${baseUrlChange}/ms/newReview/getMsClassStudentReviewDetail`,
  // 获取学生专属练数据
  getExclusivePracticeInfo: `${baseUrlChange}/api/student/practice/getExclusivePracticeInfo`,
  // 学生视角导出
  exportMsClassLessonReviewInfo: `${baseUrlChange}/ms/newReview/exportMsClassLessonReviewInfo`,
  // 讲次视角导出
  exportMsClassLessonReviewInfoNew: `${baseUrlChange}/ms/newReview/export/lesson`,
  // 修改练习题结果
  msPcTopicUpdate: `${baseUrlChange}/ms/newReview/msPcTopicUpdate`,
  // 获取二维码链接
  getQrCodeUrl: 'https://sq-private-dev2.ghost.aixuexi.com/atlas/wxMini/urlLink',
  // 通过classId获取classCode
  getClassCode: `${baseUrlChange}/ms/newReview/classDetail/{classId}`,
};
